import { z } from "zod";

export type AmountInput = number | string;
export const isAmount = (value: unknown): value is AmountInput => {
  const num = Number(value);
  return num >= 0 && Number(num.toFixed(2)) === num;
};
export const amount = z
  .union([z.number(), z.string()])
  .refine((input) => Number(input) >= 0, {
    message: `Τα ποσά δεν μπορούν να είναι αρνητικά.`,
  })
  .refine(isAmount, {
    message: `Τα ποσά μπορούν να έχουν μέχρι 2 δεκαδικά ψηφία`,
  })
  .transform((input) => String(input));

const onlyDigits = (input: string) => input.replace(/[^\d]/g, "");
const stripLeadingZeroes = (input: string) => input.replace(/^0+/g, "");
const stripTailingZeroes = (input: string) => input.replace(/0+$/g, "");
const splitAtLastDelimiter = (
  input: string,
  ...delimiters: [string, ...string[]]
): [string, string | false] => {
  const pos = delimiters
    .map((delimiter) => input.lastIndexOf(delimiter))
    .reduce((maxPos, pos) => (pos > maxPos ? pos : maxPos), -1);
  return pos === -1
    ? [input, false]
    : [input.slice(0, pos), input.slice(pos + 1, input.length)];
};
const zeroIfEmpty = (s: string) => (s === "" ? "0" : s);
const formatIntegral = (s: string) =>
  zeroIfEmpty(stripLeadingZeroes(onlyDigits(s)));
const formatDecimal = (s: string) =>
  zeroIfEmpty(stripTailingZeroes(onlyDigits(s)));

export const formatAmount = (input: string = "0") => {
  const [integral, decimal] = splitAtLastDelimiter(input, ",", ".");
  return decimal === false
    ? formatIntegral(integral)
    : `${formatIntegral(integral)}.${formatDecimal(decimal)}`;
};

export const formatAmountOnEdit = (input: string = "0") => {
  const [integral, decimal] = splitAtLastDelimiter(input, ",", ".");
  return decimal === false
    ? integral === ""
      ? ""
      : formatIntegral(integral)
    : `${formatIntegral(integral)}.${onlyDigits(decimal)}`;
};
